import { render } from "./DefaultCard.vue?vue&type=template&id=20ab97f9&ts=true"
import script from "./DefaultCard.vue?vue&type=script&lang=ts"
export * from "./DefaultCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__